import { useRef, useState } from "react";
import PropTypes from "prop-types";

import { ArrowButton, Button, DoubleButtonContainer } from "./styled";
import { ButtonsPopup, SVG } from "../index";

const DoubleButton = ({ onClick, title, children }) => {
  const [visible, setVisible] = useState(false);
  const containerRef = useRef();

  return (
    <DoubleButtonContainer ref={containerRef}>
      <Button onClick={onClick}>{title}</Button>

      <ArrowButton onClick={() => setVisible((prev) => !prev)}>
        <SVG.DownArrowIcon />
      </ArrowButton>

      <ButtonsPopup containerRef={containerRef} visible={visible} setVisible={setVisible}>
        {children}
      </ButtonsPopup>
    </DoubleButtonContainer>
  );
};

DoubleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default DoubleButton;
